import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["date", "onChange", "dateFormat", "minDate", "maxDate", "dateRange", "maxWidth", "placeholder", "flyoverZIndex", "excludedDates", "inputContext"];
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { withTheme } from '@emotion/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FlyoverBuilder } from '../Flyover/FlyoverBuilder';
import { withInputContext } from '../Form/withInputContext';
import { ArrowDownIcon, CalendarIcon } from '../icons';
import { TextInput } from '../TextInput';
import { fromThemeColors } from '../Theme';
import { withTranslate } from '../util';
import { Calendar } from './Calendar/Calendar';
import { canSelectDate } from './Calendar/dateUtils';
import { StyledDatepicker } from './DatePicker.styled';
var _DatePickerBase = /*#__PURE__*/function (_React$Component) {
  function _DatePickerBase(_props) {
    var _this;
    _classCallCheck(this, _DatePickerBase);
    _this = _callSuper(this, _DatePickerBase, [_props]);
    _defineProperty(_this, "setFocusedDate", function (focusedDate) {
      if (!_this.isDateInRange(focusedDate)) {
        return;
      }
      _this.setState({
        focusedDate: focusedDate || undefined
      });
    });
    _defineProperty(_this, "onChange", function (date, closeFlyover) {
      if (!_this.isDateInRange(date)) {
        return;
      }
      _this.setState({
        dateInput: _this.formatDate(date),
        focusedDate: undefined
      });
      var previousDate = _this.props.date || new Date();
      if (date) {
        date.setHours(previousDate.getHours(), previousDate.getMinutes(), previousDate.getSeconds(), previousDate.getMilliseconds());
      }
      _this.props.onChange(date);
      closeFlyover === null || closeFlyover === void 0 ? void 0 : closeFlyover();
    });
    _defineProperty(_this, "setDateString", function (dateInput) {
      _this.setState({
        dateInput: dateInput
      });
    });
    _defineProperty(_this, "onKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.saveDate();
      }
    });
    _defineProperty(_this, "saveDate", function () {
      _this.props.inputContext.makeDirty();
      if (!_this.state.dateInput.trim()) {
        _this.onChange(null);
        return;
      }
      var dateFormat = dayjs().locale(getLanguage()).localeData().longDateFormat('L');
      var date = dayjs(_this.state.dateInput, _this.props.dateFormat || dateFormat);
      if (!date.isValid() || !_this.isDateInRange(date.toDate())) {
        _this.setState(function (_, props) {
          return {
            dateInput: props.date ? _this.formatDate(props.date) : '',
            focusedDate: undefined
          };
        });
        return;
      }
      _this.onChange(date.toDate());
    });
    dayjs.extend(relativeTime);
    dayjs.extend(customParseFormat);
    dayjs.extend(localeData);
    dayjs.extend(localizedFormat);
    _this.state = {
      dateInput: _this.props.date ? _this.formatDate(_this.props.date) : ''
    };
    return _this;
  }
  _inherits(_DatePickerBase, _React$Component);
  return _createClass(_DatePickerBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var textIconColor = fromThemeColors('secondaryText')(this.props);
      var _this$props = this.props,
        date = _this$props.date,
        onChange = _this$props.onChange,
        dateFormat = _this$props.dateFormat,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        dateRange = _this$props.dateRange,
        _this$props$maxWidth = _this$props.maxWidth,
        maxWidth = _this$props$maxWidth === void 0 ? '300px' : _this$props$maxWidth,
        placeholder = _this$props.placeholder,
        flyoverZIndex = _this$props.flyoverZIndex,
        excludedDates = _this$props.excludedDates,
        inputContext = _this$props.inputContext,
        textInputProps = _objectWithoutProperties(_this$props, _excluded);
      var flyoverDisabled = textInputProps.disabled || textInputProps.readOnly;
      return /*#__PURE__*/React.createElement(FlyoverBuilder, {
        flyover: function flyover(_ref) {
          var closeFlyover = _ref.closeFlyover;
          return /*#__PURE__*/React.createElement(StyledDatepicker, null, /*#__PURE__*/React.createElement(Calendar, {
            date: date,
            onChange: function onChange(newDate) {
              return _this2.onChange(newDate, closeFlyover);
            },
            focusedDate: _this2.state.focusedDate,
            onFocusChange: _this2.setFocusedDate,
            dateRange: dateRange,
            minDate: minDate,
            maxDate: maxDate,
            excludedDates: excludedDates
          }));
        },
        onToggle: function onToggle(isOpen) {
          var isClosing = !isOpen;
          if (isClosing) {
            inputContext.makeDirty();
          }
        },
        disabled: flyoverDisabled,
        zIndex: flyoverZIndex
      }, function (flyoverProps) {
        return /*#__PURE__*/React.createElement("div", _extends({}, flyoverProps, {
          style: {
            maxWidth: maxWidth
          }
        }), /*#__PURE__*/React.createElement(TextInput, _extends({}, textInputProps, {
          autoComplete: "off",
          forceShowValidation: inputContext.isDirty,
          placeholder: placeholder || _this2.props.t('citrix-ui:date.select_date'),
          maxWidth: maxWidth,
          value: _this2.state.dateInput || '',
          icon: /*#__PURE__*/React.createElement(CalendarIcon, {
            size: 16,
            color: textIconColor
          }),
          secondaryIcon: flyoverDisabled ? undefined : /*#__PURE__*/React.createElement(ArrowDownIcon, {
            size: 16,
            color: textIconColor
          }),
          onChange: _this2.setDateString,
          onBlur: _this2.saveDate,
          onFocus: function onFocus() {
            return flyoverProps.onClick();
          },
          onKeyDown: _this2.onKeyDown
        })));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (!this.props.date) {
        return;
      }
      if (!prevProps.date || prevProps.date.getMonth() !== this.props.date.getMonth() || prevProps.date.getDate() !== this.props.date.getDate() || prevProps.date.getFullYear() !== this.props.date.getFullYear() || prevProps.dateFormat !== this.props.dateFormat) {
        this.setState(function (_, props) {
          return {
            dateInput: _this3.formatDate(props.date)
          };
        });
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return date ? dayjs(date).locale(getLanguage()).format(this.props.dateFormat || 'L') : '';
    }
  }, {
    key: "isDateInRange",
    value: function isDateInRange(date) {
      if (date === null) {
        return true;
      }
      return canSelectDate({
        date: date,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        excludedDates: this.props.excludedDates
      });
    }
  }]);
}(React.Component);
export var DatePickerBase = withInputContext(withTheme(withTranslate(_DatePickerBase)));